<ng-container *transloco="let t">
  <ng-container *ngIf="editForm$ | async as editForm">
    <ng-container [formGroup]="editForm" *ngIf="step$ | async as step">
      <div class="row" formGroupName="config" *ngIf="config$ | async as config">
        <div class="col-12">
          <gt-enhanced-autocomplete label="{{t('plan-step-procedure-edit.procedureId')}}" formControlName="procedureId"
            [searchFn]="procedureSearchFn" [labelFn]="procedureLabelFn"
            displayedValue="{{config.procedureId | procedureName | async}}">
          </gt-enhanced-autocomplete>
        </div>
        <ng-container *ngIf="isStart$ | async">
          <div class="col-6">
            <mat-checkbox formControlName="autoAssign">{{t('plan-step-procedure-edit.autoAssign')}}</mat-checkbox>
          </div>
          <div class="col-6">
            <mat-checkbox formControlName="autoPick">{{t('plan-step-procedure-edit.autoPick')}}</mat-checkbox>
          </div>
        </ng-container>
        <div class="col-12">
          {{t('plan-step-procedure-edit.executableBy')}}
        </div>
        <div class="col-6">
          <gt-enhanced-autocomplete label="{{t('plan-step-procedure-edit.executableByWorkGroupId')}}"
            formControlName="executableByWorkGroupId" [searchFn]="workGroupSearchFn" [labelFn]="workGroupLabelFn"
            displayedValue="{{config.executableByWorkGroupId | workGroupName | async}}">
          </gt-enhanced-autocomplete>
        </div>

        <div class="col-12">
          <data-collector-edit label="{{t('plan-step-procedure-edit.executableByDataCollectedValues')}}" [mode]="mode"
            [currentPlanId]="step.planId" [currentPlanStepId]="step.id"
            [currentProcedureId]="currentProcedureId$ | async"
            [configs]="(executableByDataCollectedValues$ | async) || []"
            (configAdded)="addExecutableByDataCollectedValues($event)"
            (configRemoved)="removeExecutableByDataCollectedValues($event)">
          </data-collector-edit>
        </div>

        <div class="col-12">
          <gt-enhanced-interval label="{{t('plan-step-procedure-edit.estimatedDuration')}}"
            formControlName="estimatedDuration"></gt-enhanced-interval>
        </div>
        <div class="col-12">
          <gt-enhanced-interval label="{{t('plan-step-procedure-edit.waitingTimeout')}}"
            formControlName="waitingTimeout">
          </gt-enhanced-interval>
        </div>
        <div class="col-12">
          <gt-enhanced-interval label="{{t('plan-step-procedure-edit.pausedTimeout')}}" formControlName="pausedTimeout">
          </gt-enhanced-interval>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
